import {debounce} from '@/utils'

export default {
  install: function (Vue) {
    Vue.prototype.isWX = navigator.userAgent.match(/MicroMessenger/i)
    /**
     *
     * @param 获取url参数
     * @returns 值
     */
    Vue.prototype.getQueryString = function (name) {
      let match = undefined
      let href = window.location.href
      let index = href.indexOf('?')
      if (index > -1 && href.match(new RegExp(name, 'i'))) {
        let queryStr = href.slice(index + 1).replace(/#([^?]+)/g, '')
        let matches = queryStr.match(new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'))
        match = matches && matches[2] ? decodeURIComponent(matches[2]) : undefined
      }
      // 可能结尾会有多余的 "/"
      if (match) {
        match = match.replace(/\/$/, "")
      }
      return match
    }
    /**
     * 初始化微信配置
     */
    Vue.prototype.getWeiXinLocation = function (configs, fn) {
      try {
        if (typeof wx != 'undefined') {
          function _getLocation() {
            wx.getLocation({
              type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
              success: function (res) {
                // let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                // let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                // let speed = res.speed; // 速度，以米/每秒计
                // let accuracy = res.accuracy; // 位置精度
                fn && fn(res)
              },
              fail: function (data) { //调用失败
                fn && fn({
                  myErrorType: 'fail',
                  data: data
                })
              },
              cancel: function (data) { //用户取消
                fn && fn({
                  myErrorType: 'cancel',
                  data: data
                })
              }
            })
          }
          if(!window.isWxregistryConfig) {
            window.isWxregistryConfig = true;
            wx.config({
              debug: false,
              appId: configs.appId, // 必填，公众号的唯一标识
              timestamp: configs.timestamp, // 必填，生成签名的时间戳
              nonceStr: configs.noncestr, // 必填，生成签名的随机串
              signature: configs.signature, // 必填，签名，见附录1
              jsApiList: [
                'getLocation' //地理信息,
              ]
            })
            wx.ready(function () {
              window.isWxConfigReady = true;
              _getLocation();
            })
            wx.error(function (res) {
              window.isWxregistryConfig = false;
              console.log(res)
              console.log('微信error')
              // alert(res.errMsg)
              // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            })
          } else if(window.isWxConfigReady && window.isWxregistryConfig) {
            _getLocation();
          }
        }
      } catch (e) {}

    }
    //腾讯点位
    Vue.prototype.setTencent = function (name) {
      try {
        MtaH5 && MtaH5.clickStat(name)
      } catch (e) {

      }
    }
    //获取用户支付宝的绑定情况
    Vue.prototype.getBindState = function () {
      this.$http.post('/api/customer/account/aliPayOrBankBinding').then(res => {
        if (!res.errorCode && res.results) {
          this.$store.commit('SET_SOME_BIND_STATIC', !!(res.results.alipayBinding || res.results.bankBinding))
          this.$store.commit('SET_ALI_ACCOUNT', res.results.aliAccount || '')
          this.$store.commit("SET_ALIPAYDATA", res.results)
          this.$store.commit("SET_ALIPAY_SHOW", res.results.isShowPop)
        }
      })
    }

    //获取用户微信绑定情况
    Vue.prototype.getBindWechatState = function(callBack) {
      this.$axios.post("/api/account/wx/bindInfo").then(res => {
        if(res && !res.errorCode) {
          res = res.results || {}
          callBack && callBack(res);
        } else {
          this.showToast(res.errorStr)
        }
      });

    }

    /**
     * 禁止冒泡事件
     */
    Vue.directive('touchPrevent', {
      inserted(el) {
        el.addEventListener('touchmove', function (ev) {
          ev.stopPropagation()
          ev.stopImmediatePropagation()
        })
      }
    })
    /**
     * 下拉加载 兼容弹跳
     */
    Vue.directive('bottomLoad', {
      inserted(el, binding) {
        let isBottomLoad = !binding.value.isNotBottomLoad;
        let isTopRefresh = binding.value.isTopRefresh || false
        if (isBottomLoad) {
          let addData = binding.value.handle
          let distance = binding.value.distance
          el.style.height = window.innerHeight - el.getBoundingClientRect().top + 'px'
          el.style.overflowX = 'hidden'
          el.style.overflowY = 'scroll'
          el.style.webkitOverflowScrolling = 'touch'
          el.addEventListener('scroll', () => {
            if (el.scrollTop + el.clientHeight + distance >= el.scrollHeight) {
              if (window.bottomLoadTimer) {
                clearTimeout(window.bottomLoadTimer)
              }
              window.bottomLoadTimer = setTimeout(function () {
                addData()
                delete window.bottomLoadTimer
              }, 300)
            }
          })
          setTimeout(function () {
            if (el.clientHeight >= el.scrollHeight) {
              addData()
            }
          }, 500)
        }
        /**
         * 如果开启上拉刷新
         */
        if (isTopRefresh) {
          let refreshFn = binding.value.refreshFn
          let startY = 0 //手指触摸最开始的Y坐标
          let change = 0 //滑动的距离
          el.addEventListener('touchstart', (e) => {
            e.stopPropagation()
            startY = e.touches[0].pageY
            el.style.transition = 'all  0s'
            change = 0

          })
          el.addEventListener('touchmove', (e) => {
            e.stopPropagation()

            change = e.touches[0].pageY - startY
            if (el.scrollTop <= 0 && change > 0) {
              e.preventDefault()
            }
            if (!el.scrollTop && change > 0 && (change < 50)) {
              el.style.transform = 'translateY(' + change + 'px)'
            }
          })

          el.addEventListener('touchend', (e) => {
            e.stopPropagation()
            if (el.scrollTop <= 0) {
              el.style.transition = 'all ease 0.5s'
              el.style.transform = 'translateY(0)'
              if (change > 20) {
                refreshFn && refreshFn()
              }
              change = 0
            } else {
              el.style.transform = 'translateY(0)'
            }
          })
        }
      }
    })
    /**
     * 钱格式转换格式
     */
    Vue.filter('money', (money) => {
      return money
    })
    /**
     * 银行卡号转换格式
     */
    Vue.filter('bank', input => {
      // let temp = String(input).split('');
      // let gap = 4;
      // while (gap < temp.length) {
      //   temp.splice(gap, 0, ' ');
      //   gap += 6;
      // }
      // return temp.join('').trim()
      return input
    })
    /**
     * 设置下方的高度
     */
    Vue.directive('growHeight', {
      inserted(el) {
        el.style.height = window.innerHeight - el.getBoundingClientRect().top + 'px'
      }
    })

    function getDomTop() {
      const notice = document.querySelector('.notice')
      let noticeTop = notice ? notice.scrollHeight + 7 : 0
      const topInfo = document.querySelector('.top-info')
      let domTop = topInfo ? topInfo.getBoundingClientRect().y : 0
      console.log(domTop >= noticeTop ? 0 : domTop - noticeTop)
      return domTop >= noticeTop ? 0 : domTop - noticeTop
    }


    let extraClass = ''
    function loadSlide (el, binding) {
      let scope = binding.value.scope
      let moveEle = scope.$refs.content
      let endMethod = binding.value.endMethod
      let isLoadPull = binding.value.isLoadPull || false
      let pullMethod = binding.value.pullMethod
      let directions = binding.value.directions || ['x', 'y']
      let allowDirection = {
        isX: directions.filter(item => item==='x').length > 0,
        isY: directions.filter(item => item==='y').length > 0
      }
      extraClass = binding.value.extraClass

      let pullBg = null
      let pullEnough = null // 未显示：null；没到1：false；1：true
      moveEle.style.width = '-webkit-fill-available'
      let touch = {
        beforeX: 0,
        beforeY: 0,
        startX: 0,
        startY: 0,
        processX: 0,
        processY: 0,
        endX: 0,
        endY: 0,
        isUpDown: null,  // 上下 或者 左右
      }
      if (isLoadPull && !document.querySelector(`.${el.className} .pull-bg`)) {
        let pullDom = document.createElement('div')
        pullDom.setAttribute('class', `pull-ctr ${extraClass ? extraClass: ''}`)
        pullDom.innerHTML = '' +
          '    <div class="pull-bg" ref="pullBg">\n' +
          '        <img class="pull-first" src="https://cdn.julanling.com/h5/load-more.svg" alt="">\n' +
          '            <span class="pull-text">松开立即刷新</span>\n' +
          '    </div>'
        el.insertBefore(pullDom, moveEle)
        pullBg = pullDom
      }

      function _getBefore () {
        return moveEle.style.transform && moveEle.style.transform.split('(')[1].split(',')
      }

      function _touchStart(event) {
        moveEle.style.transition = 'none .3s ease-in'
        touch.startX = event.touches[0].clientX
        touch.startY = event.touches[0].clientY
        let before = _getBefore(el)
        touch.beforeX = before && parseFloat(before[0]) || 0
        touch.beforeY = before && parseFloat(before[1]) || 0
      }

      function _touchMove(event) {
        touch.processX = event.touches[0].clientX
        touch.processY = event.touches[0].clientY
        let movedX = touch.processX - touch.startX
        let movedY = touch.processY - touch.startY
        if (touch.isUpDown === null) {
          touch.isUpDown = Math.abs(movedX) <= Math.abs(movedY)
        }
        if (touch.isUpDown) {
          if (allowDirection.isY) {
            const rootDom = document.scrollingElement || document.documentElement || document.body
            let top = rootDom.scrollTop || window.pageYOffset || getDomTop()
            if (movedY > 0 && top === 0) {
              event.preventDefault()
              moveEle.style.transform = `translate3d(${touch.beforeX}px, ${touch.beforeY + movedY}px, 0)`
              if (isLoadPull) {
                if (movedY > 40) {
                  if (movedY < 80) {
                    let scale = ((movedY - 40) / 40).toFixed(2)
                    pullBg.style.cssText = '-webkit-transform: scale(' + scale + ');transform: scale(' + scale + ');'
                    pullEnough = false
                  } else {
                    pullBg.style.cssText = '-webkit-transform: scale(1);transform: scale(1);'
                    pullEnough = true
                  }
                }
              }
            }
          }
        } else {
          if (allowDirection.isX) {
            moveEle.style.transform = `translate3d(${touch.beforeX + movedX}px, ${touch.beforeY}, 0)`
          }
        }
      }

      function _touchEnd(event) {
        moveEle.style.transition = 'all .3s ease-in'
        touch.endX = event.changedTouches[0].clientX
        touch.endY = event.changedTouches[0].clientY
        let movedX = touch.endX - touch.startX
        let movedY = touch.endY - touch.startY
        let tempArr = moveEle.style.transform.replace(/translate3d|\(|\)/g, '').split(',')
        let curTran = {
          x: parseFloat(tempArr[0]),
          y: parseFloat(tempArr[1]),
        }
        if (touch.isUpDown && isLoadPull) {
          if (pullEnough === true) {
            // 上拉到了足够距离，触发上拉刷新
            moveEle.style.transform = `translate3d(${curTran.x}px, 60px, 0)`
            pullMethod()
            setTimeout(() => {
              pullBg.style.cssText = '-webkit-transform: scale(0);transform: scale(0);'
              moveEle.style.transform = `translate3d(${curTran.x}px, 0, 0)`
              pullEnough = null
            }, 500)
          } else {
            pullBg.style.cssText = '-webkit-transform: scale(0);transform: scale(0);'
            moveEle.style.transform = `translate3d(${curTran.x}px, 0, 0)`
            pullEnough = null
          }
        }
        if (touch.isUpDown) {
          endMethod(movedY <= 0 ? 'top' : 'bottom', movedY)
        } else {
          endMethod(movedX >= 0 ? 'left' : 'right', movedX)
        }
        touch.isUpDown = null
      }

      function removeListener() {
        el.removeEventListener('touchstart', _touchStart)
        el.removeEventListener('touchmove', _touchMove)
        el.removeEventListener('touchend', _touchEnd)
      }

      removeListener()
      el.addEventListener('touchstart', _touchStart)
      el.addEventListener('touchmove', _touchMove)
      el.addEventListener('touchend', _touchEnd)
    }

    /**
     * 通用页面轮播组件
     *
     * 使用方法:
     * v-slide="binding"
     * 指令绑定在screen元素上
     * 子类中宽度被隐藏的元素一定要有 ref="content"
     *
     * binding {
     *      scope: this,
     *      moveEle, // transform这个属性想放在哪个dom上，通过$refs.content获取
     *      endMethod, // touchend的时候执行的方法
     *      isLoadPull: false, // 是否加载下拉加载，默认不加载
     *      pullMethod:, // 加载下拉加载时，触发的方法
     *      directions: ['x', 'y'], // 应该允许的方向，x->左右滑，y->上下滑
     * }
     *
     * 当touchend时，会触发endMethod(direction, distance)
     */
    Vue.directive('slide', {
      inserted: loadSlide,
      update: function (el, binding) {
        if (binding.value.extraClass !== extraClass) {
          extraClass = binding.value.extraClass
          const classList = extraClass.split(' ')
          classList.map(item => {
            let domClassed = document.querySelector('.pull-ctr').classList
            let domClassName = document.querySelector('.pull-ctr').className
            domClassName.indexOf(item) === -1 ? domClassed.add(item): ''
          })
        }
      }
    }),
    
    // Date对象格式化方法
    Date.prototype.format = function(fmt = 'yyyy-MM-dd') { 
      var map = { 
        "M+" : this.getMonth()+1,                 //月份 
        "d+" : this.getDate(),                    //日 
        "h+" : this.getHours(),                   //小时 
        "m+" : this.getMinutes(),                 //分 
        "s+" : this.getSeconds(),                 //秒 
        "q+" : Math.floor((this.getMonth()+3)/3), //季度 
        "S" : this.getMilliseconds()             //毫秒 
      }; 
      if(/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
      }
      for(let key in map) {
        if(new RegExp("("+ key +")").test(fmt)){
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (map[key]) : (("00"+ map[key]).substr((""+ map[key]).length)));
        }
      }
      return fmt; 
     }
  }
}
